(() => {
  'use strict';
  const instances = new Map();
  const mount = (root) => {
    if (instances.has(root)) return;
    const track = root.querySelector('[data-inspiration-track]');
    const slides = [...root.querySelectorAll('[data-inspiration-slide]')];
    const choices = [...root.querySelectorAll('[data-inspiration-choice]')];
    const navigation = root.querySelector('[data-inspiration-navigation]');
    const status = root.querySelector('[data-inspiration-status]');
    if (!track || slides.length < 2 || !navigation) return;
    const controller = new AbortController();
    const options = { signal: controller.signal };
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    let selected = 0;
    let frame = 0;
    const update = (index) => {
      selected = Math.max(0, Math.min(slides.length - 1, index));
      choices.forEach((button, i) => button.setAttribute('aria-pressed', String(i === selected)));
      if (status) status.textContent = `${selected + 1} / ${slides.length} · ${choices[selected]?.textContent.trim() || ''}`;
    };
    const move = (index, smooth = true) => {
      const next = (index + slides.length) % slides.length;
      update(next);
      track.scrollTo({ left: next * track.clientWidth, behavior: smooth && !reducedMotion.matches ? 'smooth' : 'instant' });
    };
    choices.forEach((button, index) => button.addEventListener('click', () => move(index), options));
    root.querySelector('[data-inspiration-previous]')?.addEventListener('click', () => move(selected - 1), options);
    root.querySelector('[data-inspiration-next]')?.addEventListener('click', () => move(selected + 1), options);
    track.addEventListener('keydown', (event) => {
      if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
      event.preventDefault();
      move(event.key === 'Home' ? 0 : event.key === 'End' ? slides.length - 1 : selected + (event.key === 'ArrowRight' ? 1 : -1));
    }, options);
    track.addEventListener('scroll', () => {
      if (frame) return;
      frame = requestAnimationFrame(() => {
        frame = 0;
        if (track.clientWidth) update(Math.round(track.scrollLeft / track.clientWidth));
      });
    }, { ...options, passive: true });
    let width = track.clientWidth;
    const observer = new ResizeObserver(() => {
      if (width === track.clientWidth) return;
      width = track.clientWidth;
      move(selected, false);
    });
    observer.observe(track);
    navigation.hidden = false;
    update(0);
    instances.set(root, () => {
      controller.abort();
      observer.disconnect();
      cancelAnimationFrame(frame);
    });
  };
  const mountWithin = (container) => {
    if (container.matches?.('[data-inspiration-gallery]')) mount(container);
    container.querySelectorAll?.('[data-inspiration-gallery]').forEach(mount);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => mountWithin(document), { once: true });
  else mountWithin(document);
  document.addEventListener('shopify:section:load', (event) => mountWithin(event.target));
  document.addEventListener('shopify:section:unload', (event) => {
    instances.forEach((cleanup, root) => {
      if (root === event.target || event.target.contains(root)) {
        cleanup();
        instances.delete(root);
      }
    });
  });
})();
